import React from 'react';

const FolderIcon = class extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" stroke="none" style={this.props.style||{}}>
				<path d="M4,12H28V26a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2ZM26,7H13L11.58582,5.58582A1.99993,1.99993,0,0,0,10.17157,5H6A2,2,0,0,0,4,7v3H28V9A2,2,0,0,0,26,7Z"/>
			</svg>
		);
	}
}

export default FolderIcon;